import { capitalizeFirst } from "../../utility";

export const createSubmoduleListMixin = (entityName = 'product', primaryKey = '', {
  selectedClickedEntity = '',
} = {}) => {
  if (!selectedClickedEntity) {
    selectedClickedEntity = `selectedClicked${capitalizeFirst(entityName)}`;
  }
  if (!primaryKey) {
    primaryKey = `${entityName}_id`;
  }
  return {
    data() {
      return {
        [selectedClickedEntity]: null,
      };
    },
    methods: {
      selectedRow: function (item) {
        return (
          `${this.$route.params?.[primaryKey]}` === `${item[primaryKey]}`
        );
      },
    }
  }
}